import {createLocalizationContext} from "@variocube/app-ui";
import {getWordingFlavor, WordingFlavor} from "../flavor";

export const {StorageLocalizationProvider, useLocalization} = createLocalizationContext<typeof import("./locales/en.json")>({
	load: lang => import(`./locales/${lang}.json`),
	missing: location.hostname == "localhost" ? key => `??${key}??` : "fallback",
	fallback: "en",
});

export const SUPPORTED_LANGUAGES = [
	{language: "de", displayName: "Deutsch"},
	{language: "en", displayName: "English"},
	{language: "fr", displayName: "Français"},
] as const;

export type TFunc = ReturnType<typeof useLocalization>["t"];
export type HasKeyFunc = ReturnType<typeof useLocalization>["hasKey"];
export type Keys = Parameters<TFunc>[0];

/**
 * Hook to get the wording flavor for translation key resolution.
 * Returns "default" for smalox/daylox, "boxlox" for boxlox.
 *
 * Usage:
 *   const wordingFlavor = useWordingFlavor();
 *   t(`compartments.single.${wordingFlavor}`)
 *
 * This allows a single translation file per language with sub-keys for
 * flavor-specific wording, reducing bundle size and maintenance overhead.
 */
export function useWordingFlavor(): WordingFlavor {
	return getWordingFlavor();
}
